import { useEffect } from 'react';

export function useFocusMethod() {
  function onMouseDown() {
    document.body.classList.add('focus-with-mouse');
  }

  function onKeyDown() {
    document.body.classList.remove('focus-with-mouse');
  }

  useEffect(() => {
    window.addEventListener('mousedown', onMouseDown);
    window.addEventListener('keydown', onKeyDown);

    return () => {
      window.removeEventListener('mousedown', onMouseDown);
      window.removeEventListener('keydown', onKeyDown);
    };
  }, []);
}
